import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className='mx-auto py-36 md:py-48 px-5 md:px-10 lg:px-36'>
            {/* ---------------------  */}

            <p className=' font-bold'>Privacy Policy for <span className=' text-[#fd4475] uppercase'> construction tools manufacture's </span> users :</p>

            <p>At  construction tools manufacture, accessible from https://skillice.com/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by  construction tools manufacture and how we use it.</p>

            <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>

            <p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in  construction tools manufacture. </p>

            <p className=' font-bold pt-5'>Consent</p>

            <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>

            <p className=' font-bold pt-5'>Third Party Privacy Policies</p>

            <p> construction tools manufacture's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. </p>

            <p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.</p>


            {/* ---------------------  */}
        </div>
    );
};

export default PrivacyPolicy;